import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DropdownBoxComponent} from './dropdown/dropdown-box.component';
import {ObjectiveFormComponent} from './objective-form/objective-form.component';
import {IonicModule} from '@ionic/angular';
import {ObjectiveComponent} from './objective/objective.component';
import {QuestionnaireInputComponent} from './questionnaire-input/questionnaire-input.component';
import {FormsModule} from '@angular/forms';
import {FeedbackComponent} from './feedback/feedback.component';
import {NgSelectModule} from "@ng-select/ng-select";
import {TranslateModule} from "@ngx-translate/core";
import {QuestionnaireTextComponent} from './questionnaire-text/questionnaire-text.component';
import {MomentModule} from 'ngx-moment';
import {StatusCheckboxComponent} from './status-checkbox/status-checkbox.component';
import {ComponentsModule} from '../../components/components.module';
import {PipesModule} from '../../../pipes/pipes.module';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        FormsModule,
        NgSelectModule,
        TranslateModule,
        MomentModule,
        ComponentsModule,
        PipesModule,
    ],
    declarations: [
        DropdownBoxComponent,
        ObjectiveFormComponent,
        ObjectiveComponent,
        QuestionnaireInputComponent,
        QuestionnaireTextComponent,
        FeedbackComponent,
        StatusCheckboxComponent,
    ],
    exports: [
        DropdownBoxComponent,
        ObjectiveFormComponent,
        ObjectiveComponent,
        QuestionnaireInputComponent,
        QuestionnaireTextComponent,
        FeedbackComponent,
        StatusCheckboxComponent,
    ]
})
export class ComponentsReviewModule {
}
